import React from 'react';
import './Qna.css'
const QnA = () => {
    return (
        <div className='qna'>
            <div className='qna-div'>
                <h2>What Is React & How Does It Actually Work?</h2>
                <p>ReactJS is one of the most popular JavaScript libraries for
                    mobile and web application development. Created by Facebook,
                    React contains a collection of reusable JavaScript code snippets used for user interface (UI)
                    building called components.</p>
            </div>
            <div className='qna-div'>
                <h2>What Is the main different props vs state?</h2>
                <p>Props are used to pass data from one component to another.
                    The state is a local data storage that is local to the
                    component only and cannot be passed to othe
                    r components. </p>
            </div>
            <div className='qna-div'>
                <h2>What IsuseEffect use in react without datat load?</h2>
                <p>They let you use state and other React features without writing a class.
                    The Effect Hook lets you perform side effects in function components: ..</p>
            </div>
        </div>
    );
};

export default QnA;